import React, { useState, useEffect, memo } from 'react';

const Clock = memo(() => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDateTime = (date) => {
    return date.toLocaleTimeString('en-AU', { 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit', 
      hour12: true, 
      timeZone: 'Australia/Melbourne' 
    }) + 
    ' • ' + 
    date.toLocaleDateString('en-AU', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric', 
      timeZone: 'Australia/Melbourne' 
    });
  };

  const formatTimeOnly = (date) => {
    return date.toLocaleTimeString('en-AU', { 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit', 
      hour12: true, 
      timeZone: 'Australia/Melbourne' 
    });
  };

  return (
    <div className='header__date'>
      <span className='header__date--desktop'>{formatDateTime(currentTime)}</span>
      <span className='header__date--mobile'>{formatTimeOnly(currentTime)}</span>
    </div>
  );
});

export default Clock;